import { render, staticRenderFns } from "./AddRangeFilter.vue?vue&type=template&id=40edac60&"
import script from "./AddRangeFilter.vue?vue&type=script&lang=ts&"
export * from "./AddRangeFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VBtn,VRangeSlider})
